import reduce from 'lodash/reduce';

import isLimitationsReached from '~/src/features/tariffBuilder/selectors/isLimitationsReached';
import { TCost } from '~/src/features/tariffBuilder/types/entity';

import { TInitialState } from '../reducer';
import { EEntity } from '../types/EEntity';

/**
 * Get purchase option list (cost variations) by the entity name (EEntity) and the entity ID
 * @param entityName
 * @param id
 */
const getEntityPurchaseOptions = (
    entityName: Extract<EEntity, EEntity.routers | EEntity.decoders>,
    id: number,
) => (state: TInitialState) => {
    const entity = state[entityName][id];
    const limitations = isLimitationsReached(entityName)(state);

    return reduce(entity.costs, (result: Record<number, TCost & { disabled?: boolean }>, value, key) => {
        result[Number(key)] = value;

        // purchase do not need to disabled
        if (value.period === 1) {
            return result;
        }

        // if limits reached by an installment purchase and a selected cost of current entity is purchase we should disable installment options
        result[Number(key)].disabled = limitations.installment && entity.quantity === 0;

        return result;
    }, {});
};

export default getEntityPurchaseOptions;
